import { patchBodySignatureQueryFunction } from '@/modules/adjusterReportModules/queries/patchSignature/patchBodySignatureQueryFunction';
import { patchInitialVisitSignatureQueryFunction } from '@/modules/adjusterReportModules/queries/patchSignature/patchInitialVisitSignatureQueryFunction';
import { patchPropertyCulpritSignatureQueryFunction } from '@/modules/adjusterReportModules/queries/patchSignature/patchPropertyCulpritSignatureQueryFunction';
import { patchPropertyDamagedSignatureQueryFunction } from '@/modules/adjusterReportModules/queries/patchSignature/patchPropertyDamagedSignatureQueryFunction';
import {
  FileEnType,
  SignatureQueryParamsType,
} from '@/modules/adjusterReportModules/types/signatureQueryParams.type';
export const patchSignatureQueryOptions = (type: FileEnType) => {
  const QueryFn = (params: SignatureQueryParamsType) => {
    switch (type) {
      case 'Initial':
        return patchInitialVisitSignatureQueryFunction(params);

      case 'PropertyCulprit':
        return patchPropertyCulpritSignatureQueryFunction(params);

      case 'PropertyDamaged':
        return patchPropertyDamagedSignatureQueryFunction(params);

      default:
        return patchBodySignatureQueryFunction(params);
    }
  };

  return {
    mutationKey: ['postDamagedAdjusterDocumentImages'],
    mutationFn: (params: SignatureQueryParamsType) => QueryFn(params),
  };
};
